'use client';

import { SearchDrawer } from '@eliadmin/core/src/components/header/search-bar/search-drawer';
import { usePathname } from 'next/navigation';
import { useEffect, useState } from 'react';
import { SearchIcon } from './header-icons';

export function MobileHeaderSearch({ label, className }: { label: string; className?: string }) {
  const [open, setOpen] = useState(false);
  const pathname = usePathname();
  useEffect(() => setOpen(false), [pathname]);
  useEffect(() => {
    if (!open) return;
    const desktop = window.matchMedia('(min-width: 901px)');
    const closeOnDesktop = () => {
      if (desktop.matches) setOpen(false);
    };
    desktop.addEventListener('change', closeOnDesktop);
    return () => desktop.removeEventListener('change', closeOnDesktop);
  }, [open]);
  return (
    <SearchDrawer
      open={open}
      onOpenChange={setOpen}
      trigger={
        <button
          type="button"
          aria-label={label}
          className={(className ?? '') + ' min-[901px]:hidden'}
        >
          <SearchIcon />
        </button>
      }
    />
  );
}

/** Only the branded pill stays here; all search behavior comes from core. */
export function HeaderSearch({
  placeholder,
  className,
}: {
  placeholder: string;
  className?: string;
}) {
  return (
    <div className={className}>
      <SearchDrawer
        placeholder={placeholder}
        trigger={
          <button
            type="button"
            aria-label={placeholder}
            className="flex h-auto w-full items-center gap-0 rounded-full border-[1.5px] border-solid border-transparent bg-[#f3f5f7] py-1 pl-5 pr-1 text-left transition-[border-color,background-color] duration-200 hover:cursor-text focus-visible:border-[#00a1e6] focus-visible:bg-white"
          >
            <span className="min-w-0 flex-1 truncate py-[9px] text-[.95rem] font-normal leading-[1.5] text-[#9ca3af]">
              {placeholder}
            </span>
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-[#00a1e6] text-white">
              <SearchIcon />
            </span>
          </button>
        }
      />
    </div>
  );
}
